import React from "react";
import app from "./base";
import 'firebase/firestore'

const Home = () => {
  function resetForm() { 
    document.getElementById("quest-form").reset();
  }
  const handleSubmit = (event) => { 
    
      event.preventDefault();
      const { lang, quest, wa1, wa2, wa3, ca } = event.target.elements;

      if(quest.value.length > 0 && quest.value.length <= 90)
      {
        if(wa1.value.length > 0 && wa1.value.length <= 80){
          if(wa2.value.length > 0 && wa2.value.length <= 80){
            if(wa3.value.length > 0 && wa3.value.length <= 80){
              if(ca.value.length < 1 || ca.value.length > 80){
                alert("Correct answer have less than 1 or more than 80 characters!")
                return;
              }
            }else{
              alert("Wrong answer 3 have less than 1 or more than 80 characters!")
              return;
            }
          }else{
            alert("Wrong answer 2 have less than 1 or more than 80 characters!")
            return;
          }
        }else{
          alert("Wrong answer 1 have less than 1 or more than 80 characters!")
          return;
        }
      }else{
        alert("Question have less than 1 or more than 90 characters!")
        return;
      }

      const db = app.firestore();
      db.collection("todos").add({
          quest : quest.value,
          wAns1: wa1.value,
          wAns2: wa2.value,
          wAns3: wa3.value,
          correctAns: ca.value,
          lang: lang.value,
          status: 0
      });
      console.log(quest.value.length);
      resetForm();
      /*  
      axios({
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        url: 'https://us-central1-thewallsubmit.cloudfunctions.net/api/todos',
        data: {
          quest : quest.value,
          wAns1: wa1.value,
          wAns2: wa2.value,
          wAns3: wa3.value,
          correctAns: ca.value
        }
      }).then((response) => console.log(response))
      .catch((error) => console.log(error));
      */
  }

  return (
    <>
      <div className="head">
        <h1>The Wall Submit</h1>
        <div className="btn-logout">
        <button type="logOut" onClick={() => app.auth().signOut()}>Sign Out</button>
        </div>
        <br></br>
      <h2>Submit a question</h2>
      <p>*Please, fill all the corresponding fields before sending.</p>
      <p>Max size allowed: 90 characters per question and 40 characters per answer.</p>
      </div>
 
      <div className="container">
      <form onSubmit ={handleSubmit} id="quest-form" className="questBox">
      <div className="row">
            <div className="col-25">
              <label htmlFor="lang">Language</label>
            </div>
            <div className="col-75">
              <select id="lang" name="lang">
                <option value="ptbr">Brazilian Portuguese</option>
              </select>
            </div>
          </div>
        <div className="row">
          <div className="col-25">
              <label htmlFor="quest">Write your question (with '?', ':' or '.' symbols at end):</label>
          </div>
          <div className="col-75">
              <textarea name="question" type="text" id="quest" placeholder="Question..." style={{height:"100px"}} />
            </div>
          </div>
          <div className="row">
            <div className="col-25">
              <label htmlFor="wa1">Write a wrong answer:</label>
            </div>
            <div className="col-75">
              <textarea name="wa1" type="text" id="wa1" placeholder="Wrong Answer 1..." style={{height:"100px"}} />
            </div>
          </div>
          <div className="row">
            <div className="col-25">
                <label htmlFor="wa2">Write another wrong answer:</label>
            </div>
              <div className="col-75">
                <textarea name="wa2" type="text" id="wa2" placeholder="Wrong Answer 2..." style={{height:"100px"}} />   
              </div>    
            </div>
           <div className="row"> 
            <div className="col-25">
              <label htmlFor="wa3">Write one more wrong answer:</label>
              </div>
               <div className="col-75">
                <textarea name="wa3" type="text" id="wa3" placeholder="Wrong Answer 3..." style={{height:"100px"}} />         
            </div>
          </div>
          <div className="row">
            <div className="col-25">
              <label htmlFor="ca">Write the correct answer:</label>
              </div>
              <div className="col-75">
                <textarea name="correctAns" type="text" id="ca" placeholder="Correct Answer..." style={{height:"100px"}} />        
            </div>
          </div>
          <br></br>
          <div className="row">
           <button type="submit">Submit</button>
          </div>
      </form>
      </div>
    </>
  );
};

export default Home;